class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.addEventListener('click', (e) => {
    const wrap = e.target.closest('.cart-notification-qty');
    if (!wrap) return;

    const input = wrap.querySelector('.qty-input');
    const key = wrap.dataset.lineKey;
    if (!key || !input) return;

    let qty = parseInt(input.value || '1', 10);

    if (e.target.classList.contains('qty-plus')) {
      qty += 1;
    }

    if (e.target.classList.contains('qty-minus')) {
      qty = Math.max(1, qty - 1);
    }

    input.value = qty;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: qty
      })
    })
    .then(response => response.json())
    .then(data => {
  if (data && typeof data.item_count !== 'undefined') {
    this.updateCartIconBubbleCount(data.item_count);
    this.updateCartNotificationButtonCount(data.item_count);
  }
})
    .catch(console.error);
  });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateCartIconBubbleCount(itemCount) {
  const cartLink = document.getElementById('cart-icon-bubble');
  if (!cartLink) return;

  // Dawn-style: <div class="cart-count-bubble"><span aria-hidden="true">X</span>...</div>
  const countBubble = cartLink.querySelector('.cart-count-bubble');

  if (countBubble) {
    const visible = countBubble.querySelector('[aria-hidden="true"]');
    const hidden = countBubble.querySelector('.visually-hidden');

    if (visible) visible.textContent = itemCount;
    if (hidden) hidden.textContent = itemCount;

    // Some themes hide it with "hidden" class when empty
    countBubble.classList.toggle('hidden', Number(itemCount) === 0);
    return;
  }

  // Fallback: if your theme doesn't use .cart-count-bubble, try a generic span
  const anyCountSpan =
    cartLink.querySelector('[data-cart-count]') ||
    cartLink.querySelector('.header__cart-count') ||
    cartLink.querySelector('.cart-count');

  if (anyCountSpan) {
    anyCountSpan.textContent = itemCount;
    return;
  }

  // Last-resort fallback: DO NOT destroy icon markup.
  // If there is no svg inside, then it's safe to set textContent.
  if (!cartLink.querySelector('svg')) {
    cartLink.textContent = itemCount;
  }
}

updateCartNotificationButtonCount(itemCount) {
  const btn = document.getElementById('cart-notification-button');
  if (!btn) return;
  btn.textContent = `Peržiūrėti krepšelį (${itemCount})`;
}


  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
